<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="app-icon app-icon--large" data-identifyElement="232"><path d="M6.602 4.785L4.77 7.25c-.731.984-.942 2.668-.483 3.778 0 0 1.554 4.86 6.954 10.258s10.261 6.952 10.261 6.952c1.111.482 2.802.243 3.779-.483l2.466-1.832c.984-.731.988-1.905.024-2.634l-3.547-2.684c-.451-.342-1.228-.343-1.689.031l-2.455 1.995c-.454.369-1.242.433-1.745.13 0 0-2.537-1.403-4.851-3.717s-3.692-4.809-3.692-4.809c-.329-.534-.271-1.325.104-1.786l1.995-2.454c.369-.454.389-1.217.031-1.689L9.237 4.76c-.732-.966-1.909-.953-2.635.024zm6.063 9.429a22.256 22.256 0 002.142 2.684 20.026 20.026 0 00.901.896 22.532 22.532 0 003.324 2.538l1.959-1.592c1.332-1.082 3.354-1.107 4.706-.084l3.547 2.684c2.269 1.717 2.246 4.847-.041 6.546l-2.466 1.832c-1.644 1.222-4.186 1.578-6.087.814-.766-.256-1.956-.773-3.453-1.615-2.551-1.435-5.16-3.378-7.685-5.902s-4.469-5.133-5.904-7.683c-.882-1.568-1.407-2.8-1.581-3.369-.79-1.909-.461-4.502.78-6.171L4.64 3.326c1.695-2.28 4.828-2.311 6.546-.041l2.685 3.546c1.037 1.37.995 3.379-.084 4.706l-1.592 1.958c.124.199.281.441.47.718z" data-identifyElement="233"></path></svg>
</template>

<script>
    export default {
        name: "phone-icon"
    }
</script>

<style scoped>
svg {
    vertical-align: sub;
    fill: #647a8e;
    width: 22px;
    height: 22px;
}
</style>
